import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/upload_d2c.png'
import _imports_1 from '@/assets/image/shopcart/un_upload_d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-1ad23213"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("入荷注文のインポート")
const _hoisted_2 = { class: "upload-file-modal-content" }
const _hoisted_3 = { class: "upload-part" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_6 = { class: "upload-part-text" }
const _hoisted_7 = { class: "download-template" }
const _hoisted_8 = {
  target: "_blank",
  href: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/テンプレート_入荷予定.xlsx"
}
const _hoisted_9 = { class: "download-tip" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2.対応形式：.xlsx／.xls／.csv（20MB以下）", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3.商品データが存在しない場合、自動的にTHE CKB在庫管理画面で商品が作成されます。価格が未入力の場合は「1円」で登録されますので、「在庫管理」画面より修正してください", -1))

import { ref, onUnmounted, onMounted } from 'vue'
import { t, lang } from '@/plugins/i18n'
import UploadFailTable from './UploadFailTable.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { request } from '@/config/request/interceptors'
import { uploadAliOSS } from '@/util/useUpload'
import { ExcelImportFailMessageDTO } from '@/service/overseas'
enum TASK_STATUS {
  PROCESSING = 1,
  SUCCESS = 2,
  FAIL = 3
}


export default /*#__PURE__*/_defineComponent({
  props: ['loading'],
  emits: ['updateSuccess', 'update:loading'],
  setup(__props, { emit: emits }) {

const props = __props

const importVisible = ref(false)
const file = ref()
const fileUploadErrorList = ref<ExcelImportFailMessageDTO[]>([])
const importErrorVisible = ref(false)
const store = useStore()

const upload = (uploadFile: any) => {
  if (uploadFile.size > 20 * 1024 * 1024) {
    ElMessage.warning(t('文件大于20M,请重新上传'))
    return false
  }
  file.value = uploadFile
  importVisible.value = false
  validUpload()
  return false
}

const timer = ref<any>(null)
const validUpload = async () => {
  emits('update:loading', true)
  try {
    const res: any = await uploadAliOSS({
      file: file.value,
      path: 'overseas-wms/importTask/',
      bizType: 'transferInbound',
      readAuto: true
    })
    const res1 = await request.overseas.overseasWms.importTaskSubmitTask({
      ossUrl: res.url,
      customerShopId: store.getters.curShop,
      taskType: 1
    })

    if (res1.data) {
      await handleQueryTask(res1.data!)
    }
  } catch (error) {
    emits('update:loading', false)
  }
}

// 轮询任务状态
const handleQueryTask = async (taskId: any) => {
  emits('update:loading', true)
  ElMessage.success(t('读取文件中，即将更新数据'))
  timer.value = setInterval(async () => {
    const res = await request.overseas.overseasWms.importTaskQueryTask({
      taskId
    })
    if (res.data?.taskStatus === TASK_STATUS.SUCCESS || res.data?.taskStatus === TASK_STATUS.FAIL) {
      clearTimeout(timer.value)
      if (res.data?.taskStatus === TASK_STATUS.SUCCESS) {
        ElMessage.success('アップロードに成功')
        file.value = null
        importVisible.value = false
        emits('updateSuccess')
      }
      if (res.data?.taskStatus === TASK_STATUS.FAIL) {
        if (!res.data?.messageList?.length) ElMessage.error(res.data?.message)
        importErrorVisible.value = (res.data?.messageList?.length ?? 0) > 0
        fileUploadErrorList.value = res.data?.messageList ?? []
      }
      await request.overseas.overseasWms.importTaskDeleteTaskId({
        customerShopId: store.getters.curShop
      })
      emits('update:loading', false)
    }
  }, 2000)
}

onMounted(async () => {
  const res = await request.overseas.overseasWms.importTaskGetTaskId({
    customerShopId: store.getters.curShop
  })
  if (res.data) {
    handleQueryTask(res.data)
  }
})

onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      disabled: __props.loading,
      loading: __props.loading,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (importVisible.value = true)),
      style: {"margin-left":"10px"}
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled", "loading"]),
    _createVNode(CommonDialog, {
      visible: importVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((importVisible).value = $event)),
      width: 600,
      title: _unref(t)('导入'),
      className: "upload-file-modal",
      onCancel: _cache[2] || (_cache[2] = () => importVisible.value = false)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_upload, {
            drag: "",
            action: "",
            "before-upload": upload,
            accept: ".xls,.xlsx,.csv"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (file.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", _hoisted_5)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(!file.value ? _unref(t)('上传文件') : (file.value?.size / 1024 > 1024 ? (file.value?.size /
            1024 /
            1024).toFixed(2) + 'M'
            : (file.value?.size / 1024).toFixed(0) + 'KB')), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)('模板下载2')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('注意事项')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('1.表格数据最多为1000行，超过请分多个表格导入')), 1),
            _hoisted_10,
            _hoisted_11
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(UploadFailTable, {
      visible: importErrorVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((importErrorVisible).value = $event)),
      list: fileUploadErrorList.value
    }, null, 8, ["visible", "list"])
  ], 64))
}
}

})